import React, { useState } from "react";

// Libraries
import { connect } from "react-redux";
import { createSelector } from "@reduxjs/toolkit";

// Core
import { setNotification } from "../../../../core/notifications";
import { getUid } from "../../../../core/session";
import { db } from "../../../../core/firebase";

// Components
import Button from "../../buttons";

import { IconRight, IconSpin } from "../../icons";

function Container({ toggle, setNotification, uid }) {
    const [aanvulling, changeAanvulling] = useState("");

    const [confirmed, setConfirmed] = useState(false);
    const [loading, setLoading] = useState(false);

    const submitForm = async () => {
        setLoading(true);

        const response = await db
            .collection("aanvulling")
            .doc(uid)
            .set({
                aanvulling,
                confirmed,
                createdAt: new Date(),
            })
            .then((doc) => ({ doc }))
            .catch((error) => ({ error }));

        setLoading(false);

        if (response.error) {
            setNotification({
                error: true,
                message:
                    "Er is een fout opgetreden bij het opslaan van de informatie.",
            });
        } else {
            setNotification({
                message: "Het formulier is succesvol verstuurd!",
            });
            toggle();
        }
    };

    return (
        <div className="container container-m">
            <h3 className="fs-m a-l mb-s mt">
                Heeft u iets gemist of wilt u nog aanvullingen doen?
            </h3>
            <textarea
                className="textarea"
                placeholder="Aanvullingen"
                value={aanvulling}
                type="text"
                onChange={(e) => changeAanvulling(e.target.value)}
            />
            <div className="mt flex">
                <input
                    type="checkbox"
                    id="avg"
                    name="avg"
                    onChange={() => setConfirmed(!confirmed)}
                    value={confirmed}
                />
                <label className="ml c-gray" htmlFor="avg">
                    Ik stem toe dat de Gemeente Apeldoorn mijn aanvullingen
                    opslaat.
                </label>
            </div>
            <Button
                className="mt-m"
                text="Versturen"
                onClick={submitForm}
                disabled={!aanvulling.length || !confirmed}
            >
                {loading ? (
                    <IconSpin className="ml icon icon-sm spin" />
                ) : (
                    <IconRight className="ml icon icon-sm" />
                )}
            </Button>
        </div>
    );
}

const state = createSelector(getUid, (uid) => ({ uid }));
export default connect(state, { setNotification })(Container);
